<script setup>
import { computed } from 'vue';

// As classes ficam num .vue de propósito: o Tailwind só gera o que encontra nos
// arquivos listados no `content` do tailwind.config.js, e .js desta pasta não
// está lá.
const props = defineProps({
  tom: { type: String, default: 'neutro' },
  texto: { type: String, required: true },
});

const CORES = {
  ativo: 'bg-n-teal-3 text-n-teal-11',
  bom: 'bg-n-teal-3 text-n-teal-11',
  pago: 'bg-n-teal-3 text-n-teal-11',
  atencao: 'bg-n-amber-3 text-n-amber-11',
  inativo: 'bg-n-ruby-3 text-n-ruby-11',
  ruim: 'bg-n-ruby-3 text-n-ruby-11',
  vencido: 'bg-n-ruby-3 text-n-ruby-11',
  aberto: 'bg-n-blue-3 text-n-blue-11',
};

const cor = computed(() => CORES[props.tom] || 'bg-n-slate-3 text-n-slate-11');
</script>

<template>
  <span
    class="inline-flex items-center px-1.5 py-0.5 rounded-md text-xs font-medium whitespace-nowrap"
    :class="cor"
  >
    {{ texto }}
  </span>
</template>
